<template>
  <div style="width: 100%">
    <iframe
      src="https://alidocs.dingtalk.com/i/nodes/NkDwLng8ZLxDOvXZTapbEMBqVKMEvZBY?utm_scene=team_space"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped></style>
